import { EventLimitMetaTableCellContent } from "@/types/EventLimitMetaTableCellContent";
import { useTranslations } from "next-intl";

type TableCellContentEventLimitMetaProps = {
  value: EventLimitMetaTableCellContent;
};

export const TableCellContentEventLimitMeta: React.FC<
  TableCellContentEventLimitMetaProps
> = ({ value }) => {
  const t = useTranslations("userSettings");

  return (
    <div className="flex flex-col">
      <p className="body-2-bold">{value.name ?? ""}</p>
      <p className="body-3-medium">
        {t(value.subscriptionType ?? "EVENT_FREE")}
      </p>
    </div>
  );
};
